/** Weive Forms embed for the marketing Book a demo page. */
export const demoFormOrigin = 'https://forms.cqlghana.com';

export const demoFormKey = 'wf_d9bgjnRyfT2kgEewgB_FwMe4SwqLQgNc';
